import React from 'react';

/**
 * Vahid ikon dəsti — feather/lucide üslubunda stroke SVG-lər.
 * Bütün ikonlar 24x24 viewBox, currentColor ilə rənglənir, ona görə
 * valideyn elementin `color`-u onları avtomatik uyğunlaşdırır.
 *
 * İstifadə:  <Icon name="users" size={20} />
 *            <Icon name="star" filled />
 */

const PATHS = {
  // --- insanlar / təhsil ---
  graduation:  <><path d="M22 10L12 5 2 10l10 5 10-5z"/><path d="M6 12v5c3 2.5 9 2.5 12 0v-5"/><path d="M22 10v6"/></>,
  student:     <><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
  teacher:     <><path d="M3 4h18v12H3z"/><path d="M3 20h18"/><circle cx="12" cy="9" r="2"/><path d="M8.5 14a3.5 3.5 0 017 0"/></>,
  users:       <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>,
  crown:       <><path d="M3 7l4 3.5L12 4l5 6.5L21 7v11H3V7z"/><path d="M3 21h18"/></>,

  // --- yerlər / obyektlər ---
  school:      <><path d="M3 21V8l9-5 9 5v13"/><path d="M9 21V12h6v9"/></>,
  building:    <><path d="M3 21h18"/><path d="M5 21V6l8-3v18"/><path d="M19 21V10l-6-3"/><path d="M9 9h.01M9 12h.01M9 15h.01M9 18h.01"/></>,
  door:        <><path d="M4 21h16"/><path d="M6 21V4a1 1 0 011-1h10a1 1 0 011 1v17"/><path d="M14 12h.01"/></>,
  warehouse:   <><path d="M3 21V8l9-5 9 5v13"/><path d="M7 21v-7h10v7"/></>,

  // --- sənəd / məzmun ---
  book:        <><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></>,
  clipboard:   <><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></>,
  file:        <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6"/><path d="M9 13h6M9 17h6"/></>,
  package:     <><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M3.3 7L12 12l8.7-5"/><path d="M12 22V12"/></>,
  briefcase:   <><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></>,
  inbox:       <><path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z"/></>,
  megaphone:   <><path d="M3 11l16-6v14L3 13z"/><path d="M3 11H2a1 1 0 00-1 1v0a1 1 0 001 1h1"/><path d="M7 14.5V19a2 2 0 004 0v-3.5"/></>,
  ticket:      <><path d="M3 9a3 3 0 010 6v2a2 2 0 002 2h14a2 2 0 002-2v-2a3 3 0 010-6V7a2 2 0 00-2-2H5a2 2 0 00-2 2z"/><path d="M13 5v14"/></>,

  // --- qrafik / analitika ---
  chartLine:   <><path d="M3 3v18h18"/><path d="M7 15l4-4 3 3 5-6"/></>,
  chartBar:    <><path d="M3 3v18h18"/><path d="M8 17v-5M13 17V8M18 17v-8"/></>,
  target:      <><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5"/></>,
  trophy:      <><path d="M8 21h8M12 17v4"/><path d="M7 4h10v5a5 5 0 01-10 0V4z"/><path d="M7 6H5a2 2 0 000 4h2M17 6h2a2 2 0 010 4h-2"/></>,
  medal:       <><circle cx="12" cy="15" r="6"/><path d="M8.5 9.5L6 2h12l-2.5 7.5"/></>,

  // --- vəziyyət ---
  check:       <path d="M20 6L9 17l-5-5"/>,
  checkDouble: <><path d="M1.5 12.5l4 4 7-8"/><path d="M11 16.5l1.5 1.5 9-10"/></>,
  checkCircle: <><circle cx="12" cy="12" r="9"/><path d="M8.5 12.5l2.5 2.5 4.5-5"/></>,
  close:       <path d="M18 6L6 18M6 6l12 12"/>,
  closeCircle: <><circle cx="12" cy="12" r="9"/><path d="M15 9l-6 6M9 9l6 6"/></>,
  warning:     <><path d="M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z"/><path d="M12 9v4.5M12 17h.01"/></>,
  clock:       <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></>,
  lock:        <><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></>,
  play:        <><circle cx="12" cy="12" r="9"/><path d="M10.5 8.5l5.5 3.5-5.5 3.5v-7z"/></>,
  pin:         <><path d="M21 10c0 6-9 12-9 12S3 16 3 10a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></>,
  bell:        <><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 01-3.4 0"/></>,
  zap:         <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"/>,
  star:        <path d="M12 2.5l2.9 5.9 6.6.9-4.8 4.6 1.1 6.5-5.8-3-5.8 3 1.1-6.5L2.5 9.3l6.6-.9L12 2.5z"/>,

  // --- əməliyyat ---
  search:      <><circle cx="11" cy="11" r="7"/><path d="M20.5 20.5l-4.2-4.2"/></>,
  download:    <><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><path d="M7 10l5 5 5-5"/><path d="M12 15V3"/></>,
  upload:      <><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><path d="M17 8l-5-5-5 5"/><path d="M12 3v12"/></>,
  userPlus:    <><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><path d="M20 8v6M23 11h-6"/></>,
  save:        <><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/><path d="M17 21v-8H7v8"/><path d="M7 3v5h7"/></>,
  edit:        <><path d="M11 4H5a2 2 0 00-2 2v13a2 2 0 002 2h13a2 2 0 002-2v-6"/><path d="M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></>,
  trash:       <><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></>,
  printer:     <><path d="M6 9V3h12v6"/><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/><rect x="6" y="14" width="12" height="7"/></>,
  settings:    <><path d="M4 21v-6M4 11V3M12 21v-9M12 8V3M20 21v-5M20 12V3"/><path d="M1.5 15h5M9.5 8h5M17.5 12h5"/></>,
  paperclip:   <path d="M21.4 11L12.3 20.1a6 6 0 01-8.5-8.5l9.2-9.1a4 4 0 015.6 5.6l-9.1 9.2a2 2 0 01-2.9-2.9l8.5-8.4"/>,
  image:       <><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></>,
  camera:      <><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></>,
  calendar:    <><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 11h18"/></>,
  message:     <path d="M21 11.5a8.4 8.4 0 01-8.5 8.5 8.4 8.4 0 01-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 01-.9-3.8A8.4 8.4 0 0112.5 3a8.4 8.4 0 018.5 8.5z"/>,
  smile:       <><circle cx="12" cy="12" r="9"/><path d="M8.5 14.5s1.3 2 3.5 2 3.5-2 3.5-2"/><path d="M9.5 9.5h.01M14.5 9.5h.01"/></>,
  arrowLeft:   <><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></>,
  arrowRight:  <><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></>,
  sun:         <><circle cx="12" cy="12" r="4.5"/><path d="M12 2v2M12 20v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2 12h2M20 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4"/></>,
};

export default function Icon({ name, size = 18, strokeWidth = 1.8, filled = false, className = '', style, title, ...rest }) {
  const body = PATHS[name];
  if (!body) {
    if (process.env.NODE_ENV !== 'production') console.warn('Icon: naməlum ad —', name);
    return null;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={filled ? 0 : strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={('ems-icon ' + className).trim()}
      style={style}
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...rest}
    >
      {title && <title>{title}</title>}
      {body}
    </svg>
  );
}

export const ICON_NAMES = Object.keys(PATHS);
